import {
  Badge,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import classes from './Navigation.module.css';

const CustomListItem: FC<{
  link: string;
  name: string;
  icon: React.ReactNode;
  openDrawer?: boolean;
  badge?: number;
  count?: number;
  id?: string;
  target?: React.HTMLAttributeAnchorTarget;
  extraLink?: boolean;
}> = ({
  link,
  name,
  icon,
  openDrawer,
  badge,
  count,
  target,
  extraLink,
  id,
}) => {
  return (
    <>
      {extraLink ? (
        <a href={link} target={target}>
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              sx={{
                height: 40,
                justifyContent: openDrawer ? 'initial' : 'center',
                px: 1.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: openDrawer ? 1.5 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <Badge
                  badgeContent={badge}
                  color="error"
                  invisible={badge ? false : true}
                >
                  {icon}
                </Badge>
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
        </a>
      ) : (
        <NavLink
          to={link}
          className={({ isActive }) =>
            [isActive ? classes.active : undefined, classes.ListItemLink].join(
              ' '
            )
          }
          target={target}
        >
          <ListItem disablePadding sx={{ display: 'block' }} id={id}>
            <ListItemButton
              sx={{
                height: 40,
                justifyContent: openDrawer ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: openDrawer ? 2 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <Badge
                  badgeContent={badge}
                  color="error"
                  invisible={badge ? false : true}
                >
                  {icon}
                </Badge>
              </ListItemIcon>

              <ListItemText
                sx={{
                  opacity: openDrawer ? 1 : 0,
                }}
                className={classes.ListItemText}
              >
                <span className={classes.titleName}>{name}</span>
                {count && count > 0 ? <span>{count}</span> : null}
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </NavLink>
      )}
    </>
  );
};

export default CustomListItem;
